
import { LockDec, ValidateDec } from "@/decorators";
import { TSX, Component, Prop, Vue, Watch } from 'vue-facing-decorator'

interface Props {
  data: any
}

@Component({})
export default class extends TSX<Props>()(Vue) implements Props {
  @Prop({})
  data: any;

  submitLoading = false;

  postData = {
    /** 0 减少、1 增加 */
    type: 1,
    score: "",
    message: "",
  }

  /** 积分是整数，规则和后端 AdjustScoreDto 对齐：@IsInt + @Min(1) + @Max(9999999) */
  validateScore(v) {
    if (!v) throw '请输入调整积分'
    if (!/^\d+$/.test(String(v))) throw '积分必须为整数'
    if (Number(v) < 1) throw '调整积分必须大于 0'
    if (Number(v) > 9999999) throw '调整积分超出范围'
  }

  @ValidateDec("form")
  @LockDec("submitLoading")
  async submit() {
    await this.$postNotify("/manager/user/adjust-score", {
      id: this.data.id,
      type: this.postData.type,
      score: Number(this.postData.score),
      message: this.postData.message,
    })
    this.$emit("resolve")
  }

  close() {
    this.$emit("reject", { msg: '取消' })
  }
}
